import { render, staticRenderFns } from "./weixinKeyWord.vue?vue&type=template&id=51f73972&"
import script from "./weixinKeyWord.vue?vue&type=script&lang=js&"
export * from "./weixinKeyWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports